import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiTransaction from "../../../core/api/api.transaction";
import SplitNumber from "../_Components/SplitNumber";

export const ViewModal = ({ showModalTransaction, setShowModalTransaction, selectedTransaction }) => {
  const handleClose = () => {
    setShowModalTransaction(false);
  };
  const [itam, setItem] = useState();
  const checkAndShowItem = (item) => {
    if (item) return item;
    else return "---";
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedTransaction > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiTransaction.getTransactionById(selectedTransaction);
          if (response.succeeded == true) {
            setItem(response.data);
            //setValue("roleList", response.data.roleList);
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" onHide={handleClose} show={showModalTransaction}>
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات تراکنش </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col xs="12">
            {/* <div className="bg-light rounded shadow-2 py-2">
                            <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات فردی</div>
                            <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>  نام و نام خانوادگی  : </p>
                                    <p> {checkAndShowItem(itam?.userFullName)}</p>
                                </div>
                            </Col>
                            <Col xs="auto">    <div className="d-flex align-items-center justify-content-between">
                                <p>       شماره همراه  : </p>
                                <p>       {checkAndShowItem(itam?.phoneNumber)}</p>
                            </div>
                            </Col>
                        </div> */}

            <div className="mb-3">
              {itam?.isDeleted ? (
                <p className="bg-light-danger text-danger p-3 fw-bold rounded-3"> تراکنش حذف شده است </p>
              ) : (
                <p className="bg-light-success text-success p-3 fw-bold rounded-3"> تراکنش فعال است </p>
              )}
            </div>
            <Row className="border-bottom mb-3 mt-5">
              <h4>اطلاعات تراکنش</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> عنوان تراکنش </div>
                <div className="mt-2"> {checkAndShowItem(itam?.titleS)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted">مبلغ</div>
                <div className="mt-2">
                  <SplitNumber number={checkAndShowItem(itam?.amount)} />
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted">اعتبار</div>
                <div className="mt-2">
                  <SplitNumber number={checkAndShowItem(itam?.creditAmount)} />
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> نوع تراکنش </div>
                <div className="mt-2"> {checkAndShowItem(itam?.typeS)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> تاریخ انجام </div>
                <div className="mt-2"> {checkAndShowItem(itam?.completionDate)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> زمان انجام </div>
                <div className="mt-2"> {checkAndShowItem(itam?.completionTime)}</div>
              </Col>
              {/* <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>   مبدا :  </p>
                                    <p>   {checkAndShowItem(itam?.sourceTitle)}</p>
                                </div>
                            </Col>
                            {itam?.sourceAgency && <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>    آژانس مبدا :  </p>
                                    <p>    {checkAndShowItem(itam?.sourceAgency?.name)}</p>
                                </div>
                                {itam?.sourceAccount && <div className="d-flex align-items-center justify-content-between">
                                    <p>    حساب مبدا :  </p>
                                    <p>    {checkAndShowItem(itam?.sourceAccount?.name)}</p>
                                </div>}
                            </Col>}
                            <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>    مقصد :  </p>
                                    <p>    {checkAndShowItem(itam?.destinationTitle)}</p>
                                </div>
                            </Col>
                            {itam?.destinationAgency && <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>    آژانس مقصد :  </p>
                                    <p>    {checkAndShowItem(itam?.destinationAgency?.name)}</p>
                                </div>
                                {itam?.destinationAccount && <div className="d-flex align-items-center justify-content-between">
                                    <p>    حساب مقصد :  </p>
                                    <p>    {checkAndShowItem(itam?.destinationAccount?.name)}</p>
                                </div>}
                            </Col>} */}
              {itam?.description && (
                <Col xs="6" sm="4" lg className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> توضیحات </div>
                  <div className="mt-2" style={{ wordBreak: "break-all" }}>
                    {itam?.description}
                  </div>
                </Col>
              )}
            </Row>
            {itam?.userPayment && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات پرداخت</h4>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره پرداخت </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.id)}</div>
                </Col>
                {itam.riallBalance !== itam.userPayment.rialAmount && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مبلغ </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.rialAmount.toLocaleString())}</div>
                  </Col>
                )}
                {itam.completionDate !== itam.userPayment.paymentDate && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> تاریخ انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentDate)}</div>
                  </Col>
                )}
                {itam.completionTime !== itam.userPayment.paymentTime && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> زمان انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.paymentTime)}</div>
                  </Col>
                )}
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره کارت پرداخت </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.cardNumberPayment)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره مرجع (referenceId) </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.referenceId)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره توکن </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.tokenNumber)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره ای پی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userPayment?.userIp)}</div>
                </Col>
                {itam.description !== itam.userPayment.description && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted">توضیحات</div>
                    <div className="mt-2" style={{ wordBreak: "break-all" }}>
                      {itam?.userPayment?.description}
                    </div>
                  </Col>
                )}
              </Row>
            )}
            {itam?.basket && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات سبد خرید</h4>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره سبد </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.id)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ اصلی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.originalPrice.toLocaleString())}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ نهایی </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.basket?.price.toLocaleString())}</div>
                </Col>
                {/* <Col xs="auto">
                                    وضعیت سبد  : {itam?.basket?.status}
                                </Col> */}
              </Row>
            )}
            {itam?.userWithdrawal && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>اطلاعات درخواست برداشت وجه</h4>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره درخواست </div>
                  <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.id)}</div>
                </Col>
                {itam.riallBalance !== itam.userWithdrawal.rialAmount && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مبلغ </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.rialAmount.toLocaleString())}</div>
                  </Col>
                )}
                {itam.completionDate !== itam.userWithdrawal.paymentDate && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> تاریخ انجام </div>
                    <div className="mt-2">{checkAndShowItem(itam?.userWithdrawal?.paymentDate)}</div>
                  </Col>
                )}
                {itam.completionTime !== itam.userWithdrawal.paymentTime && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> زمان انجام </div>
                    <div className="mt-2"> {checkAndShowItem(itam?.userWithdrawal?.paymentTime)}</div>
                  </Col>
                )}
                {/* <Col xs="auto">
                                    وضعیت درخواست  : {itam?.userWithdrawal?.status}
                                </Col> */}
                {itam.userWithdrawal.destinationAccount && (
                  <Row>
                    <Col xs="12" className="mt-2 mb-5">
                      <div className="fw-bold text-center">---- اطلاعات حساب مقصد </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام بانک </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.bank)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountNumber)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب کارت </div>
                      <div className="mt-2">
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره کارت </div>
                      <div className="mt-2"> {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardNumber)}</div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره شبا </div>
                      <div className="mt-2">
                        {" "}
                        {checkAndShowItem(itam.userWithdrawal.destinationAccount.shebaNumber)}
                      </div>
                    </Col>
                  </Row>
                )}
              </Row>
            )}
            {itam?.basketLogs && itam.basketLogs?.length > 0 && (
              <Row className="border-bottom mb-3 mt-5">
                <h4>لیست تغییرات</h4>
                <Row>
                  <Col xs="2" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> شماره </div>
                  </Col>
                  <Col xs="5" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مقدار </div>
                  </Col>
                  <Col xs="5" sm="4" lg className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> توضیحات </div>
                  </Col>
                </Row>
                {itam?.basketLogs?.map((item2, index) => (
                  <Row key={index}>
                    <Col xs="2" sm="4" lg="3" className="mb-5">
                      <div> {item2.id} </div>
                    </Col>
                    <Col xs="5" sm="4" lg="3" className=" mb-5">
                      <div> {item2.value} </div>
                    </Col>
                    <Col xs="5" sm="4" lg className=" mb-5">
                      <div> {item2.description} </div>
                    </Col>
                  </Row>
                ))}
              </Row>
            )}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
